import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Flame, TrendingUp } from 'lucide-react';
const TOTAL_SECONDS = 30 * 60; // 30 minutos
const START_PERCENT = 77;
const pad = (n: number) => String(n).padStart(2, '0');
export function UrgencyBanner() {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setSecondsLeft(s => s > 0 ? s - 1 : 0);
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  // La barra "sube" lentamente desde 77% hacia ~94% a medida que corre el tiempo,
  // reforzando que los cupos se están agotando.
  const elapsed = TOTAL_SECONDS - secondsLeft;
  const percent = Math.min(94, START_PERCENT + elapsed / TOTAL_SECONDS * 17);
  return <div className="max-w-3xl mx-auto mb-5 md:mb-8" data-id="element-216">
      <div className="relative overflow-hidden rounded-2xl bg-red-600 text-white shadow-[0_10px_30px_-8px_rgba(220,38,38,0.6)] ring-1 ring-red-400/50" data-id="element-217">
        {/* Glow decorativo */}
        <motion.div aria-hidden animate={{
        opacity: [0.15, 0.35, 0.15]
      }} transition={{
        duration: 2.4,
        repeat: Infinity
      }} className="absolute -right-8 -top-8 w-40 h-40 bg-brand-gold rounded-full blur-3xl" data-id="element-218" />

        <div className="relative p-3.5 md:p-5" data-id="element-219">
          {/* Fila superior: aviso + timer */}
          <div className="flex items-center justify-between gap-3" data-id="element-220">
            <div className="flex items-center gap-2 min-w-0" data-id="element-221">
              <motion.span animate={{
              scale: [1, 1.15, 1]
            }} transition={{
              duration: 1.2,
              repeat: Infinity
            }} className="flex-shrink-0" data-id="element-222">
                <Flame className="w-5 h-5 md:w-6 md:h-6 text-brand-gold" data-id="element-223" />
              </motion.span>
              <p className="text-[11px] md:text-sm font-extrabold uppercase tracking-wide leading-tight" data-id="element-224">
                ¡Oferta por tiempo limitado!
              </p>
            </div>

            <div className="flex-shrink-0 flex items-center gap-1 bg-black/25 rounded-lg px-2.5 py-1.5 md:px-3 md:py-2 font-mono tabular-nums" data-id="element-225">
              <span className="text-lg md:text-2xl font-bold leading-none" data-id="element-226">
                {pad(minutes)}
              </span>
              <span className="text-lg md:text-2xl font-bold leading-none animate-pulse" data-id="element-227">
                :
              </span>
              <span className="text-lg md:text-2xl font-bold leading-none" data-id="element-228">
                {pad(seconds)}
              </span>
            </div>
          </div>

          {/* Mensaje de suba de precio */}
          <p className="mt-2 text-xs md:text-sm text-white/95 leading-snug flex items-start gap-1.5" data-id="element-229">
            <TrendingUp className="w-4 h-4 flex-shrink-0 mt-0.5 text-brand-gold" data-id="element-230" />
            <span data-id="element-231">
              Cuando se agoten los cupos, el precio{' '}
              <strong className="font-extrabold text-brand-gold" data-id="element-232">
                sube $10.000
              </strong>{' '}
              y no vuelve a bajar.
            </span>
          </p>

          {/* Barra de cupos */}
          <div className="mt-2.5" data-id="element-233">
            <div className="flex items-center justify-between text-[10px] md:text-xs font-semibold mb-1" data-id="element-234">
              <span className="uppercase tracking-wide text-white/80" data-id="element-235">
                Cupos ocupados
              </span>
              <span className="text-brand-gold font-bold" data-id="element-236">
                {Math.round(percent)}%
              </span>
            </div>
            <div className="h-2.5 md:h-3 w-full rounded-full bg-black/30 overflow-hidden" data-id="element-237">
              <motion.div initial={{
              width: `${START_PERCENT}%`
            }} animate={{
              width: `${percent}%`
            }} transition={{
              duration: 0.6,
              ease: 'easeOut'
            }} className="h-full rounded-full bg-brand-gold relative" data-id="element-238">
                <motion.span aria-hidden animate={{
                opacity: [0.4, 1, 0.4]
              }} transition={{
                duration: 1.6,
                repeat: Infinity
              }} className="absolute inset-0 bg-white/30" data-id="element-239" />
              </motion.div>
            </div>
            <p className="mt-1 text-[10px] md:text-xs text-white/80" data-id="element-240">
              Quedan pocos lugares a este precio.
            </p>
          </div>
        </div>
      </div>
    </div>;
}